// A transient confirmation, e.g. "License key copied" on the install screen.
//
// No Overlays/Toast instance appears on any of the 23 frames — none of them
// draws an open-overlay state — so the geometry is composed from chassis
// tokens and flagged for the /crg-ui run. The semantics are not guesswork:
// a danger toast is `role="alert"` (interrupts), everything else is
// `role="status"` (announced politely), because a copy confirmation that
// barges into a screen reader mid-sentence is worse than silence.
//
// Deliberately NOT included: a toast queue, a portal, auto-dismiss timers.
// One screen needs one toast; a manager can be built when a second does.

import "./ui.css";
import { Icon } from "./Icon";

export type ToastTone = "accent" | "nominal" | "danger";

export type ToastProps = {
  title: string;
  description?: string;
  tone?: ToastTone;
  onDismiss?: () => void;
};

export function Toast({
  title,
  description,
  tone = "accent",
  onDismiss,
}: ToastProps) {
  return (
    <div
      className="maisight-ui-toast"
      data-tone={tone}
      role={tone === "danger" ? "alert" : "status"}
    >
      <div className="maisight-ui-toast-main">
        <p className="maisight-ui-toast-title type-body">{title}</p>
        {description ? (
          <p className="maisight-ui-toast-description type-bodyS">
            {description}
          </p>
        ) : null}
      </div>
      {onDismiss ? (
        <button
          type="button"
          className="maisight-ui-toast-dismiss"
          aria-label="Dismiss"
          onClick={onDismiss}
        >
          <Icon name="x" size={16} />
        </button>
      ) : null}
    </div>
  );
}
